import React from 'react';
import { Field } from 'react-final-form';

import type { EulaType } from '@swf/core/enums';
import usePauseValidator from '@swf/core/hooks/usePauseValidator';
import useValidator from '@swf/core/hooks/useValidator';
import { required } from '@swf/core/utils/validators';
import { Checkbox } from '@swf/first';

import Label from '../Label/Label';
import styles from '../RegulatoryCheckboxes.scss';

interface Props {
  eulaType: EulaType;
  onEulaLinkClick?: () => void;
  onPrivacyLinkClick?: () => void;
}

const FirstCheckbox: React.FC<Props> = ({ eulaType, onEulaLinkClick, onPrivacyLinkClick }) => {
  const [validator] = useValidator(required());
  usePauseValidator();

  return (
    <Field name={eulaType} type="checkbox" validate={validator}>
      {({ input: { onChange, checked }, meta }) => (
        <Checkbox
          meta={meta}
          name={eulaType}
          checked={checked}
          onChange={onChange}
          className={styles.cashier}
          label={
            <Label
              variant="first"
              eulaType={eulaType}
              onEulaLinkClick={onEulaLinkClick}
              onPrivacyLinkClick={onPrivacyLinkClick}
            />
          }
        />
      )}
    </Field>
  );
};

export default FirstCheckbox;
